import { Injectable } from '@angular/core';

/** Holds current survey run token and expiry for intake flow (in-memory only). */
@Injectable({ providedIn: 'root' })
export class SurveyRunStateService {
  private runId: number | null = null;
  private token: string | null = null;
  private expiresAtUtc: string | null = null;

  setRun(runId: number, token: string, expiresAtUtc: string): void {
    this.runId = runId;
    this.token = token;
    this.expiresAtUtc = expiresAtUtc;
  }

  getRunId(): number | null {
    return this.runId;
  }

  getToken(): string | null {
    return this.token;
  }

  getExpiresAtUtc(): string | null {
    return this.expiresAtUtc;
  }

  updateToken(token: string, expiresAtUtc: string): void {
    this.token = token;
    this.expiresAtUtc = expiresAtUtc;
  }

  clear(): void {
    this.runId = null;
    this.token = null;
    this.expiresAtUtc = null;
  }
}
